<template>
  <Onboarding
    :title="title"
    :has-back-button="showBackButton"
    :on-back="onBack"
  >
    <slot />
    <ProgressBar
      slot="progress"
      :current="currentStepIndex"
      :total="totalNumberOfSteps"
    />
  </Onboarding>
</template>

<script>
import { Onboarding, ProgressBar } from '@dunia/ui';
import flowManager from '@/lib/services/flow-manager';

export default {
  name: 'UiDuniaRootForm',
  components: {
    Onboarding,
    ProgressBar,
  },
  props: {
    totalNumberOfSteps: {
      type: Number,
      required: true,
    },

    currentStepIndex: {
      type: Number,
      required: true,
    },
    isFirstStep: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    hasBackButton: {
      type: Boolean,
      required: true,
    },
    onBack: {
      type: Function,
      default: async () => flowManager.goToPreviousStep(),
    },
  },
  computed: {
    showBackButton() {
      return this.hasBackButton && !this.isFirstStep;
    },
  },
};
</script>

<style>

</style>
